var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { poPrepDiagram } from "./HardwarePrepTable";
import { PrepExporter } from "../../../project/shopdrawing/hardware/prepCanvas/PrepCanvas";
import { groupByArr, orderByStrAscending } from "nate-react-api-helpers";
import { api } from "../../../../api/API";
export function makeHwPrepDiagrams(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const element = document.createElement("div");
        document.body.appendChild(element);
        const combined = groupByArr(input, r => { const type = r.isPair ? "type: pair" : "type: single"; const deadbolt = r.hasDeadbolt ? "deadbolt: yes" : "deadbolt: no"; let cutDown = "cutDown: none"; if (r.cutDown) {
            cutDown = `cutDown: ${r.cutDown.overCutDoor} / ${r.cutDown.underCutDoor} / ${r.cutDown.underCutFrame}`;
        } const hingeQty = "hingeQty: " + r.manager.getHingeQty(); return `${type}-pair kind: ${r.pairSplitKey}-${deadbolt}-${cutDown}-${hingeQty}:v2`; }); // sort to keep order consistent
        orderByStrAscending(combined, v => v.key);
        try {
            const exp = new PrepExporter(element);
            const out = yield Promise.all(combined.map((v, index) => __awaiter(this, void 0, void 0, function* () { const cfg = v.values[0]; let rs = yield api.hardware.makePrepImage({ key: v.key }); if (rs.status === "key-missing") {
                cfg.manager.calculate();
                const img = yield exp.render(cfg.manager, "both");
                rs = yield api.hardware.makePrepImage({ key: v.key, file: img });
                if (rs.status === "key-missing")
                    throw new Error("Hardware Prep Key still missing after upload");
            } let name = alpha[index]; v.values.forEach(itm => itm.prepDiagramName = name); return { linkRef: poPrepDiagram(name), name: name, url: rs.url }; })));
            return out;
        }
        finally {
            element.remove();
        }
    });
}
const alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
